/* TWRD why-different: tabs + optional video controls. Scoped per section. */
(function () {
  'use strict';

  var KEYS = { left: 37, up: 38, right: 39, down: 40, home: 36, end: 35 };

  function visibleTabs(root) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-twrd-why-tab]'), function (t) {
      return !t.hidden;
    });
  }

  /* FEATURES: fills the full grid width. On desktop the grid height is locked
     to the height it had on the previous tab (the 4:5 media box sets it), so
     the page below does not jump when the tab opens or closes. */
  function setFeatures(root, on) {
    var was = root.classList.contains('is-features');
    var grid = root.querySelector('.twrd-why__grid');
    if (on && !was && grid && window.matchMedia('(min-width: 768px)').matches) {
      grid.style.minHeight = grid.offsetHeight + 'px';
    } else if (!on && grid) {
      grid.style.minHeight = '';
    }
    root.classList.toggle('is-features', on);
    if (on) {
      var imgs = root.querySelectorAll('[data-twrd-why-feats-panel] img[loading="lazy"]');
      Array.prototype.forEach.call(imgs, function (img) { img.loading = 'eager'; });
    }
  }

  function activate(root, index) {
    var tabs = visibleTabs(root);
    var panels = root.querySelectorAll('[data-twrd-why-panel]');
    var medias = root.querySelectorAll('[data-twrd-why-visual]');
    if (!tabs.length) return;
    if (index < 0) index = tabs.length - 1;
    if (index >= tabs.length) index = 0;

    Array.prototype.forEach.call(tabs, function (tab, i) {
      var on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    var onFeats = !!(tabs[index] && tabs[index].hasAttribute('data-twrd-why-feats-tab'));
    setFeatures(root, onFeats);
    var panelIndex = onFeats ? panels.length - 1 : index;
    Array.prototype.forEach.call(panels, function (panel, i) {
      panel.hidden = i !== panelIndex;
    });
    Array.prototype.forEach.call(medias, function (media, i) {
      media.hidden = onFeats || i !== index;
    });
    syncVideo(root);
  }

  /* Video kun paa Why-fanen. Skjult video pauses automatisk og startes igen,
     naar Why vises, medmindre brugeren selv har pauset den. */
  var AUTO = 'data-twrd-why-auto-paused';
  var USER = 'data-twrd-why-user-paused';

  /* MP4 hentes foerst, naar pladsen naermer sig skaermen (data-src -> src). */
  function ensureSrc(video) {
    setPoster(video);
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.removeAttribute('data-src');
    video.setAttribute('src', src);
  }

  /* Poster is printed as data-poster so it is not fetched during the first
     paint. It is set from here, well before the box is on screen. */
  function setPoster(video) {
    var poster = video.getAttribute('data-poster');
    if (!poster) return;
    video.removeAttribute('data-poster');
    video.setAttribute('poster', poster);
  }

  /* Observe the section, not the video: a hidden video (other tab) never
     intersects. 1.5 screen heights of margin puts the poster in place before
     the box scrolls in, also with reduced motion or a paused video. */
  function lazyPosters(root) {
    var videos = root.querySelectorAll('[data-twrd-why-video][data-poster]');
    if (!videos.length) return;
    var setAll = function () { Array.prototype.forEach.call(videos, setPoster); };
    if (!('IntersectionObserver' in window)) {
      setAll();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          setAll();
          observer.disconnect();
          return;
        }
      }
    }, { rootMargin: '150% 0px' });
    observer.observe(root);
    /* Also set them in idle time after load: the poster stays out of the LCP
       window, but is already downloaded before a fast fling on 3G reaches the box. */
    var run = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(setAll, { timeout: 2000 });
      else setTimeout(setAll, 300);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  /* Med video pr. farve ligger flere <video> i pladsen. Kun den synlige er aktiv. */
  function activeVideo(root) {
    return root.querySelector('[data-twrd-why-video-slot] [data-twrd-why-video]:not([hidden])');
  }

  function lazyVideo(root) {
    var video = activeVideo(root);
    if (!video || !video.hasAttribute('data-src')) return;
    if (!video) return;
    if (!('IntersectionObserver' in window)) {
      ensureSrc(video);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          ensureSrc(video);
          observer.disconnect();
          return;
        }
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
  }

  function syncVideo(root) {
    var slot = root.querySelector('[data-twrd-why-video-slot]');
    var video = activeVideo(root);
    if (!slot || !video) return;
    if (slot.hidden) {
      if (video.getAttribute(USER) === 'true') return;
      video.setAttribute(AUTO, 'true');
      if (!video.paused) video.pause();
      return;
    }
    if (video.getAttribute(AUTO) !== 'true') return;
    video.removeAttribute(AUTO);
    if (video.paused && video.getAttribute(USER) !== 'true') {
      ensureSrc(video);
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }
  }

  function currentIndex(root) {
    var tabs = visibleTabs(root);
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('aria-selected') === 'true') return i;
    }
    return 0;
  }

  /* Preview-only FEATURES tab (non-live themes): shown with
     ?twrd_features_preview=1, otherwise removed from the DOM. */
  function initFeaturesPreview(root) {
    var nodes = root.querySelectorAll('[data-twrd-why-feats-preview]');
    if (!nodes.length) return;
    var on = /[?&]twrd_features_preview=1(&|$)/.test(window.location.search);
    Array.prototype.forEach.call(nodes, function (n) {
      if (on) n.removeAttribute('data-twrd-why-feats-preview');
      if (on && n.hasAttribute('data-twrd-why-feats-tab')) n.hidden = false;
      if (!on) n.parentNode.removeChild(n);
    });
  }

  function initTabs(root) {
    initFeaturesPreview(root);
    var tabs = visibleTabs(root);
    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.addEventListener('click', function () {
        activate(root, i);
      });
      tab.addEventListener('keydown', function (event) {
        var code = event.keyCode;
        var next = null;
        if (code === KEYS.left || code === KEYS.up) next = currentIndex(root) - 1;
        if (code === KEYS.right || code === KEYS.down) next = currentIndex(root) + 1;
        if (code === KEYS.home) next = 0;
        if (code === KEYS.end) next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(root, next);
        var moved = visibleTabs(root);
        var target = moved[(next + moved.length) % moved.length];
        if (target) target.focus();
      });
    });
    activate(root, 0);
  }

  function initVideo(root) {
    var videos = root.querySelectorAll('[data-twrd-why-video-slot] [data-twrd-why-video]');
    if (!videos.length) return;
    var button = root.querySelector('[data-twrd-why-toggle]');
    var bar = root.querySelector('[data-twrd-why-progress-bar]');
    var slot = root.querySelector('[data-twrd-why-video-slot]');

    function setLabel() {
      var video = activeVideo(root);
      if (!button || !video) return;
      var playing = !video.paused;
      button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      button.setAttribute('data-state', playing ? 'playing' : 'paused');
    }

    if (button) {
      button.addEventListener('click', function () {
        var video = activeVideo(root);
        if (!video) return;
        if (video.paused) {
          video.removeAttribute(USER);
          ensureSrc(video);
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        } else {
          video.setAttribute(USER, 'true');
          video.pause();
        }
      });
    }

    Array.prototype.forEach.call(videos, function (video) {
      video.addEventListener('play', function () {
        /* Autoplay der starter sent, mens en anden fane eller farve er aaben. */
        if (video.hidden || (slot && slot.hidden && video.getAttribute(USER) !== 'true')) {
          video.setAttribute(AUTO, 'true');
          video.pause();
          return;
        }
        setLabel();
      });
      video.addEventListener('pause', setLabel);
      video.addEventListener('timeupdate', function () {
        if (video.hidden || !bar || !video.duration || isNaN(video.duration)) return;
        var ratio = Math.max(0, Math.min(1, video.currentTime / video.duration));
        bar.style.transform = 'scaleX(' + ratio + ')';
      });
    });
    setLabel();
    syncVideo(root);
  }

  /* Video pr. farve: sektionen skriver {variant-id: farve-slug}. Ved
     variant-skift vises farvens video (data-twrd-why-colour), ellers
     standard-videoen (data-twrd-why-colour=""). Skjulte videoer har
     preload="none" og faar src foerst, naar de vises. */
  function initColourVideos(root) {
    var tag = root.querySelector('[data-twrd-why-video-colours]');
    if (!tag) return;
    var map;
    try {
      map = JSON.parse(tag.textContent);
    } catch (e) {
      return;
    }
    var slot = root.querySelector('[data-twrd-why-video-slot]');
    var bar = root.querySelector('[data-twrd-why-progress-bar]');

    var sync = function () {
      var slug = map[variantId()];
      if (typeof slug !== 'string') return;
      var target = slot.querySelector('[data-twrd-why-video][data-twrd-why-colour="' + slug + '"]') ||
        slot.querySelector('[data-twrd-why-video][data-twrd-why-colour=""]');
      var current = activeVideo(root);
      if (!target || target === current) return;
      var userPaused = current && current.getAttribute(USER) === 'true';
      if (current) {
        current.pause();
        current.hidden = true;
      }
      target.hidden = false;
      target.setAttribute('preload', 'metadata');
      if (bar) bar.style.transform = 'scaleX(0)';
      if (userPaused) {
        target.setAttribute(USER, 'true');
        return;
      }
      target.removeAttribute(USER);
      if (slot.hidden) {
        target.setAttribute(AUTO, 'true');
        return;
      }
      ensureSrc(target);
      var attempt = target.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    };
    var schedule = function () {
      window.setTimeout(sync, 80);
    };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.section--product-single')) schedule();
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.section--product-single')) schedule();
    });
    document.addEventListener('on:variant:change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variant:changed', schedule);
    sync();
  }

  /* Variant-skift: billederne foelger den valgte farve og Style.
     Sektionen skriver alle kombinationer i et JSON-tag
     ({variants: {id: "farve|view"}, sets: {"farve|view": [why, details, care]}}).
     Her laeses kun variant-id'et fra produktformularen, og src/srcset/alt
     byttes. Boksen har fast 4:5, saa intet flytter sig. Det synlige billede
     hentes foerst i baggrunden og byttes naar det er klar. Med video foran
     billederne angiver data-twrd-why-slot pladsen i saettet; videoen springes over. */
  function variantId() {
    var scope = document.querySelector('.section--product-single') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || scope.querySelector('[name="id"]');
    var id = input ? String(input.value || '').trim() : '';
    if (!id) {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m) id = m[1];
    }
    return id;
  }

  function setImage(img, item) {
    if (item.srcset) img.setAttribute('srcset', item.srcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', item.src);
    /* Pin-markoeren (" #2" sidst i alt) er kun til galleriet. Liquid fjerner
       den allerede. Samme regel som snippets/twrd-alt-clean.liquid, for en sikkerheds skyld. */
    img.setAttribute('alt', String(item.alt || '').replace(/\s*#[1-9]\d?\s*$/, ''));
  }

  function applySet(root, data, key) {
    var set = data.sets[key];
    if (!set || root.getAttribute('data-twrd-why-key') === key) return;
    root.setAttribute('data-twrd-why-key', key);
    var imgs = root.querySelectorAll('img[data-twrd-why-visual]');
    Array.prototype.forEach.call(imgs, function (img, i) {
      var slotAttr = img.getAttribute('data-twrd-why-slot');
      var item = set[slotAttr !== null && slotAttr !== '' ? Number(slotAttr) : i];
      if (!item || !item.src || img.getAttribute('src') === item.src) return;
      if (img.hidden) {
        setImage(img, item);
        return;
      }
      var probe = new Image();
      var done = false;
      var swap = function () {
        if (done) return;
        done = true;
        /* Et nyere skift har overhalet dette. */
        if (root.getAttribute('data-twrd-why-key') !== key) return;
        setImage(img, item);
      };
      probe.onload = swap;
      probe.onerror = swap;
      if (img.sizes) probe.sizes = img.sizes;
      if (item.srcset) probe.srcset = item.srcset;
      probe.src = item.src;
    });
  }

  function initVariants(root) {
    var tag = root.querySelector('[data-twrd-why-sets]');
    if (!tag) return;
    var data;
    try {
      data = JSON.parse(tag.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.sets || !data.variants) return;
    root.setAttribute('data-twrd-why-key', data.current || '');

    var sync = function () {
      var key = data.variants[variantId()];
      if (typeof key === 'string') applySet(root, data, key);
    };
    var schedule = function () {
      window.setTimeout(sync, 80);
    };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.section--product-single')) schedule();
    });
    document.addEventListener('on:variant:change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variant:changed', schedule);
    sync();
  }

  /* #features: open the FEATURES tab (or reach the FEATURES block) and scroll to it. Runs on
     click of any a[href="#features"] and on page load. Without JS the
     anchor (id="features") just jumps to the section. */
  function openFeatures(root, smooth) {
    var tabs = visibleTabs(root);
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].hasAttribute('data-twrd-why-feats-tab')) {
        if (currentIndex(root) !== i) activate(root, i);
        root.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        return true;
      }
    }
    /* FEATURES as its own block under the tabs (2026-10-26): scroll to it. */
    var block = root.querySelector('.twrd-why__featblock#features');
    if (block) {
      block.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      return true;
    }
    return false;
  }

  function initFeaturesLink() {
    if (document.documentElement.getAttribute('data-twrd-feat-link') === 'true') return;
    document.documentElement.setAttribute('data-twrd-feat-link', 'true');
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href="#features"]');
      if (!a) return;
      var root = document.querySelector('[data-twrd-why]');
      if (root && openFeatures(root, true)) e.preventDefault();
    });
    if (window.location.hash === '#features') {
      var root = document.querySelector('[data-twrd-why]');
      if (!root) return;
      /* The theme adds ?variant= and the gallery, fonts and images still move
         the page after this runs, so one jump lands short. Jump again on load
         and once more after it, unless the visitor has scrolled by then. */
      var userMoved = false;
      var stop = function () { userMoved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
        window.addEventListener(type, stop, { passive: true, once: true });
      });
      var go = function () { if (!userMoved) openFeatures(root, false); };
      window.setTimeout(go, 60);
      var later = function () { go(); window.setTimeout(go, 600); };
      if (document.readyState === 'complete') later();
      else window.addEventListener('load', later, { once: true });
    }
  }

  /* FEATURES block (2026-10-26, Oliver): with more than 3 tiles, desktop shows
     the first row of 3 and a "Show all" button. Phones keep the swipe row.
     Recounted when the colour switch hides or shows tiles. */
  var FEAT_LIMIT = 3;
  var FEAT_SHOW = 3;
  function initFeatsCollapse(root) {
    var block = root.querySelector('.twrd-why__featblock');
    var ul = block && block.querySelector('.twrd-why__feats');
    if (!ul) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'twrd-why__feats-more';
    btn.hidden = true;
    ul.parentNode.insertBefore(btn, ul.nextSibling);
    var open = false;
    var apply = function () {
      /* Count what shows: other colours are [hidden], empty slots are display: none in CSS. */
      Array.prototype.forEach.call(ul.children, function (li) { li.removeAttribute('data-twrd-feat-more'); });
      var items = Array.prototype.filter.call(ul.children, function (li) {
        return !li.hidden && window.getComputedStyle(li).display !== 'none';
      });
      var collapse = items.length > FEAT_LIMIT;
      if (collapse) items.slice(FEAT_SHOW).forEach(function (li) { li.setAttribute('data-twrd-feat-more', ''); });
      block.classList.toggle('is-collapsed', collapse && !open);
      btn.hidden = !collapse;
      btn.textContent = open ? 'Show less' : 'Show all ' + items.length + ' features';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    btn.addEventListener('click', function () {
      open = !open;
      apply();
      if (!open) block.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(ul, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    apply();
  }

  function init() {
    initFeaturesLink();
    var roots = document.querySelectorAll('[data-twrd-why]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-twrd-why-ready') === 'true') return;
      root.setAttribute('data-twrd-why-ready', 'true');
      initTabs(root);
      lazyPosters(root);
      initVideo(root);
      lazyVideo(root);
      initVariants(root);
      initColourVideos(root);
      initFeatsCollapse(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
